var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravelTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5526 6.24528C23.3166 7.64237 21.332 8.85204 20.568 7.45495C19.8039 6.05786 21.7886 4.84819 22.5526 6.24528Z",
    fill: "#00FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3592 1.66672C19.6888 2.47317 18.5428 4.57752 17.2132 3.77107C15.8837 2.96462 17.0297 0.860276 18.3592 1.66672Z",
    fill: "#00FFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4829 6.04846V11.6936C10.4829 13.253 11.6796 14.5162 13.1569 14.5162H17.741V12.0968H13.1569C12.9465 12.0968 12.7749 11.9157 12.7749 11.6936V6.04846H10.4829Z",
    fill: "#00FFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.942 12.5C21.942 15.173 20.9363 17.7371 19.1442 19.6274C17.3535 21.5191 14.9242 22.5807 12.3919 22.5807C9.85961 22.5807 7.43046 21.5191 5.63964 19.6274C3.84751 17.7373 2.84178 15.173 2.84178 12.5C2.84178 9.82706 3.84751 7.26296 5.63964 5.37264C7.43027 3.48096 9.85961 2.41935 12.3919 2.41935H13.5379V0H12.3919C9.25082 0 6.23976 1.31677 4.01766 3.66051C1.79727 6.00582 0.549805 9.18428 0.549805 12.5C0.549805 15.8157 1.79727 18.9939 4.01766 21.3395C6.23953 23.6832 9.2507 25 12.3919 25C15.5331 25 18.544 23.6832 20.7661 21.3395C22.9865 18.9942 24.234 15.8157 24.234 12.5V11.2903H21.942L21.942 12.5Z",
    fill: "#A4A4A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelTime);
export default __webpack_public_path__ + "static/media/TravelTime.f84b4874.svg";
export { ForwardRef as ReactComponent };